import LegalPage from './LegalPage';
import { COMPANY } from './legalConstants';

export default function Privacy() {
  return (
    <LegalPage title="Privacybeleid" testId="legal-page-privacy">
      <p>
        Dit privacybeleid beschrijft hoe{' '}
        <strong>{COMPANY.legalName}</strong> persoonsgegevens verwerkt
        in overeenstemming met de Algemene Verordening
        Gegevensbescherming (AVG / GDPR — Verordening (EU) 2016/679)
        en de Belgische uitvoeringswet.
      </p>

      <h2>1. Verwerkingsverantwoordelijke</h2>
      <ul>
        <li>{COMPANY.legalName}</li>
        <li>BTW: {COMPANY.vatNumber}</li>
        <li>E-mail: {COMPANY.email}</li>
      </ul>

      <h2>2. Welke gegevens verwerken wij?</h2>
      <ul>
        <li>
          <strong>Identificatie- en contactgegevens</strong>: naam,
          e-mail, telefoonnummer (optioneel), leveringsadres,
          facturatieadres.
        </li>
        <li>
          <strong>Bestelgegevens</strong>: bestelde producten, prijzen,
          betalingsstatus, leveringsmethode.
        </li>
        <li>
          <strong>Technische gegevens</strong>: alleen functionele
          cookies (winkelmandje, sessie). Geen analytics-trackers
          actief — zie het{' '}
          <a href="/cookies" data-testid="link-cookies">cookiebeleid</a>.
        </li>
        <li>
          <strong>B2B-gegevens</strong> (indien van toepassing):
          ondernemingsnummer, BTW-nummer, bedrijfsnaam.
        </li>
      </ul>

      <h2>3. Doeleinden en rechtsgrond</h2>
      <ul>
        <li>
          Uitvoering van de koopovereenkomst (art. 6.1.b AVG).
        </li>
        <li>
          Wettelijke verplichtingen, zoals facturatie en
          BTW-administratie (art. 6.1.c AVG).
        </li>
        <li>
          Gerechtvaardigd belang voor fraudepreventie en
          beveiliging (art. 6.1.f AVG).
        </li>
        <li>
          Toestemming voor optionele communicatie zoals
          nieuwsbrieven (art. 6.1.a AVG) — momenteel niet actief.
        </li>
      </ul>

      <h2>4. Met wie delen we gegevens?</h2>
      <ul>
        <li>
          <strong>Mollie B.V.</strong> — betalingsverwerking.
        </li>
        <li>
          <strong>Active Ants</strong> — logistieke fulfilment (op dit
          ogenblik enkel in read-only modus; uitgaande synchronisatie
          is uitgeschakeld).
        </li>
        <li>
          <strong>Yuki</strong> — boekhoudkundige verwerking
          (handmatige export).
        </li>
        <li>
          <strong>Resend</strong> — versturen van transactionele
          e-mails.
        </li>
        <li>
          <strong>bpost</strong> — verzending van pakketten.
        </li>
        <li>
          Bevoegde overheidsinstanties indien wettelijk verplicht.
        </li>
      </ul>
      <p>
        Met al deze verwerkers worden de wettelijk vereiste
        verwerkingsovereenkomsten afgesloten. <em>
          TODO juridische review: DPA-tracker bevestigen vóór live.
        </em>
      </p>

      <h2>5. Bewaartermijnen</h2>
      <p>
        Bestel- en facturatiegegevens bewaren wij in functie van
        wettelijke bewaartermijnen (Belgische BTW- en
        boekhoudwetgeving: 7 jaar). Account- en contactgegevens
        bewaren wij zolang de klantrelatie loopt, en daarna nog
        maximaal 5 jaar tenzij wettelijke termijnen langer zijn.
      </p>

      <h2>6. Uw rechten</h2>
      <ul>
        <li>Recht op inzage, verbetering en wissing.</li>
        <li>Recht op beperking en bezwaar.</li>
        <li>Recht op gegevensoverdraagbaarheid.</li>
        <li>Recht om toestemming in te trekken (indien van toepassing).</li>
        <li>
          Recht om klacht in te dienen bij de Belgische
          Gegevensbeschermingsautoriteit (
          <a
            href="https://www.gegevensbeschermingsautoriteit.be"
            target="_blank"
            rel="noopener noreferrer"
          >
            gegevensbeschermingsautoriteit.be
          </a>
          ).
        </li>
      </ul>
      <p>
        Verzoeken kan u indienen via{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>

      <h2>7. Beveiliging</h2>
      <p>
        Wij nemen passende technische en organisatorische
        maatregelen, waaronder versleutelde transmissie (HTTPS),
        toegangscontrole en geminimaliseerde gegevensopslag.
      </p>

      <h2>8. Wijzigingen</h2>
      <p>
        Dit beleid kan worden bijgewerkt. De meest recente versie is
        altijd op deze pagina beschikbaar; de datum staat bovenaan.
      </p>
    </LegalPage>
  );
}
